import FormElementMixin from '../mixins/FormElementMixin.js';
import MatrixFormTrigger from "../triggers/MatrixFormTrigger";
import FormTrigger from "../triggers/FormTrigger";

Vue.asyncComponent('ak-input-group', {
    mixins: [FormElementMixin],
    data() {
        return {
            localValue: {}
        }
    },
    props: {
        controls: {
            type: Array,
            default: () => [],
        },
        controlErrors: {
            type: Array|Object,
        },
        hideFieldset: {
            type: Boolean,
        },
        relationString: {
            type: String,
            required: false
        },
        currentObjectId: {
            type: String,
            required: false
        }
    },
    watch: {
        /**
         * Update the currentValue when the active controls change
         */
        controls() {
            const values = {};
            this.controls.forEach(control => {
                values[control.id] = control.formControl.value;
            });

            this.currentValue = values;
        }
    },
    methods: {
        /**
         * Retrieves the attributes of a widget.
         *
         * @param {Object} widget - The widget object.
         * @returns {Object} - The attributes of the widget.
         */
        widgetAttributes(widget) {
            let attributes = {
                id: widget.id,
                ...widget.formControl,
                ...widget.attributes,
                error: null,
                hasError: false,
                controlErrors: [], // we need to reset the controlErrors ass wel in case we have an inputGroup as a child widget
                value: this.currentValue[widget.id],
                relationString: this.relationString,
                currentObjectId: 'new' // we force the current object id to new because otherwise the select-ids call of relation widget won't work.
            };

            if (! this.controlErrors) {
                return attributes;
            }

            if (this.controlErrors[widget.id]) {
                attributes = {...attributes, ...this.controlErrors[widget.id]};
                return attributes;
            }

            Object.keys(widget).forEach(property => {
                // add other props from the widgets
                if(! ['formControl', 'attributes','slot'].includes(property) && widget[property] !== null) {
                    attributes[property] = widget[property];
                }
            });

            return attributes;
        },
        /**
         * Validate the child widgets
         * @param $event
         * @param widgetId
         * @param rowId
         * @param groupId
         */
        validateChildWidget($event, widgetId) {
            this.$emit('blur', new FormTrigger(widgetId));
        },
        /**
         * Set current value
         *
         * We use this method to set the current value every time a child widget value changes
         * This is needed because vue reactivty won't work on the currentValue object because the object doesn't always
         * contain the child widget ids from the start. This causes vue reactivity to break
         *
         * @param value
         * @param id
         */
        setCurrentValue(value, id) {
            // We need to clone the current values
            const values = {...this.currentValue};
            values[id] = value;

            // We set the current value object completely for vue reactivity to work.
            this.currentValue = values;
        }
    },
    created() {
        if(!this.currentValue || !Object.values(this.currentValue).length) {
            this.currentValue = {};
            this.controls.forEach(control => {
                this.currentValue[control.id] = control.formControl.value;
            })
        }
    }
}, 'form/controls/ak-input-group.html');
